import { useForm } from "react-hook-form"
import { useRecoilState } from "recoil"
import styled from "styled-components"
import { categoriesState } from "../../atoms"


const Input = styled.input`
  border: none;
  background-color: #ffcaca;
  border-radius:0.5rem;
  color:#000000;
  padding: 2em ;
  margin: 0.2rem 0.4rem 0 0.2rem ;
`
const Button = styled.button`
  border: none;
  cursor: pointer;
  background-color:#ff8686;
  border-radius:0.8rem;
  padding: 1em ;
  color: white;
`

interface Form {
  category: string
}

const MakeCategory = () => {
  const [categories, setCategories] = useRecoilState(categoriesState)
  const { register, handleSubmit, setValue, setError, formState: { errors } } = useForm<Form>()
  const handleValid = ({ category }: Form) => {
    if (categories.includes(category)) {
      setError("category", {
        type: "manual",
        message: "동일한 이름의 카테고리가 이미 존재합니다",
      });
      return;
    }
    setCategories((oldCategories) => [
      ...oldCategories,
      category,
    ]);
    setValue("category", "");
  }
  return (
    <>
      <form onSubmit={handleSubmit(handleValid)}>
        <Input  {...register("category", {
          required: "카테고리를 입력해주세요",
        })}
          placeholder="ex). 오늘 할 일 / 내일 할 일"
        />
        <Button>카테고리 만들기➕</Button>
      </form>
      {errors && <span>{errors.category?.message}</span>}
    </>
  )
}

export default MakeCategory